import * as React from 'react';
import { Card } from 'reactstrap';
import { HttpRequest } from '../../../util/http';
import { ContentCardHeader } from '../../ui/ContentCardHeader';
import { DataGrid, DataGridSortOrder } from '../../ui/DataGrid';
import { FontAwesomeIcon } from '../../ui/FontAwesomeIcon';
import { GetAllHierarchies } from '../../util';
import { HierarchyEditor } from '../HierarchyEditor';
import { IHierarchy } from '../interfaces';

interface IHierarchiesDataGridProps {
  reloadHierarchiesFn?: (loadHierarchiesFn: () => Promise<void>) => void
}

interface IHierarchiesDataGridState {
  hierarchies: IHierarchy[]
  sortOrder: DataGridSortOrder
  sortBy: keyof IHierarchy
  hierarchyInEditMode?: IHierarchy
  loading: boolean
}

export class HierarchiesDataGrid extends React.Component<IHierarchiesDataGridProps, IHierarchiesDataGridState> {
  state: IHierarchiesDataGridState = {
    hierarchies: [],
    sortOrder: 'desc',
    sortBy: 'hierarchy',
    loading: false
  }

  componentWillMount() {
    this.loadHierarchies()

    if (this.props.reloadHierarchiesFn) {
      this.props.reloadHierarchiesFn(this.loadHierarchies.bind(this))
    }
  }

  loadHierarchies() {
    this.setState({ loading: true })

    return GetAllHierarchies()
      .then((hierarchies) => this.setState({ hierarchies, loading: false }))
  }

  deleteHierarchy(hierarchyContainer: IHierarchy) {
    const { hierarchies } = this.state
    const endpoint = '/scripts/hierarchies/delete'
    const { hierarchy } = hierarchyContainer
    const data = { hierarchy }
    const method = 'POST'
    const confirmDeletion = window.confirm(`Are you sure you want to delete "${hierarchy}" hierarchy?`)

    if (!confirmDeletion) { return }

    const hierarchyIndex = hierarchies.findIndex((h) => h.hierarchy === hierarchy)

    hierarchies.splice(hierarchyIndex, 1)

    this.setState({ hierarchies })

    HttpRequest.fetch(endpoint, { data, method })
      .finally(() => this.loadHierarchies())
  }

  setEditMode(hierarchyInEditMode?: IHierarchy) {
    this.setState({ hierarchyInEditMode })
  }

  fireHierarchyUpdated() {
    return this.loadHierarchies().then(() => this.setEditMode(undefined));
  }

  render() {
    const { hierarchyInEditMode, loading } = this.state

    return (
      <Card>
        <ContentCardHeader header="Hierarchies" sticky borderBottom loading={loading} />
        <DataGrid<IHierarchy>
          records={this.state.hierarchies}
          sortBy={this.state.sortBy}
          sortOrder={this.state.sortOrder}
          onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder })}
          showSubComponent={(hierarchy) => hierarchyInEditMode && hierarchyInEditMode.hierarchy === hierarchy.hierarchy}
          subComponent={() =>
            <HierarchyEditor editMode={hierarchyInEditMode}
              onCancel={() => this.setEditMode(undefined)}
              onSuccess={() => this.fireHierarchyUpdated()}
            />
          }
          columns={[
            {
              header: 'Hierarchy', render: (hierarchy) =>
                <a href="javascript:void(0)"
                  onClick={() => this.setEditMode(hierarchy)}>
                  <FontAwesomeIcon icon="edit" verticalAlign="initial" size="md" />
                  <span>&nbsp;{hierarchy.hierarchy}</span>
                </a>
            },
            { header: 'Sort Order', property: 'sort_order' },
            {
              header: 'Delete', align: 'center', sortable: false, render: (hierarchy) => (
                <a href="javascript:void(0)" onClick={() => this.deleteHierarchy(hierarchy)}>
                  <i className="fa fa-fw fa-trash-alt" />
                </a>
              )
            }
          ]} />
      </Card>
    )
  }
}
